module.exports = __webpack_public_path__ + "static/video-5c2a9a2460c56d9ff533ea306ac94630.mp4";